module.exports = __webpack_public_path__ + "static/media/ios-volume-low.cde172bf.svg";